export default __webpack_public_path__ + "8ae9ce3061e163d256ab3fb36c1e0447.png";